module.exports = __webpack_public_path__ + "static/media/shopping-basket.c4529696.svg";